import * as api from "./client";

export type TableColumn = {
  name: string;
  type: string;
};

type TableListResponse = {
  tables: string[];
};

type TableRowsResponse = {
  tableName: string;
  columns: TableColumn[];
  rows: Record<string, unknown>[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
};

export type FilterOperator =
  | "eq"
  | "neq"
  | "contains"
  | "starts_with"
  | "ends_with"
  | "gt"
  | "lt"
  | "gte"
  | "lte"
  | "is_null"
  | "is_not_null";

export const researchDbService = {
  async listTables(): Promise<TableListResponse> {
    return api.get<TableListResponse>("/v1/research/research-db/tables");
  },

  async getRows(
    tableName: string,
    options: {
      limit?: number;
      offset?: number;
      filterColumn?: string;
      filterOp?: FilterOperator;
      filterValue?: string;
    } = {},
  ): Promise<TableRowsResponse> {
    const params = new URLSearchParams();
    if (options.limit != null) params.set("limit", String(options.limit));
    if (options.offset != null) params.set("offset", String(options.offset));
    if (options.filterColumn) params.set("filterColumn", options.filterColumn);
    if (options.filterOp) params.set("filterOp", options.filterOp);
    if (
      options.filterValue != null &&
      options.filterOp !== "is_null" &&
      options.filterOp !== "is_not_null"
    ) {
      params.set("filterValue", options.filterValue);
    }
    const query = params.toString();
    return api.get<TableRowsResponse>(
      `/v1/research/research-db/tables/${encodeURIComponent(tableName)}${query ? `?${query}` : ""}`,
    );
  },
};
